import React, { Component } from "react";
import get from "lodash/get";
import { MEMBER_UPDATED } from "@quintype/components";
import { connect } from "react-redux";

const mapStateToProps = state => ({
  member: get(state, ["member"], null),
  isLoginOpen: get(state, ["isLoginOpen"], false),
  config: state.qt.config
});

const mapDispatchToProps = dispatch => ({
  openLoginTemplate: () => dispatch({ type: "OPEN_LOGIN_TEMPLATE" }),
  closeLoginTemplate: () => dispatch({ type: "CLOSE_LOGIN_TEMPLATE" }),
  updateMember: member => dispatch({ type: MEMBER_UPDATED, member })
});

export class DynamicImportSSO extends Component {
  constructor(props) {
    super(props);
    this.SSOWrapperBase = null;
    this.state = {
      isSSOLoaded: false
    };
  }

  componentDidUpdate(prevProp) {
    const prevIsLoginOpen = get(prevProp, ["isLoginOpen"], false);
    const currentIsLoginOpen = get(this.props, ["isLoginOpen"], false);

    if (prevIsLoginOpen !== currentIsLoginOpen) {
      this.dynamicImport();
    }
  }

  dynamicImport() {
    import(/* webpackChunkName: "SSOWrapperBase" */ "./sso-wrapper").then(({ SSOWrapperBase }) => {
      this.SSOWrapperBase = SSOWrapperBase;
      this.setState({ isSSOLoaded: true });
    });
  }

  render() {
    if (!this.state.isSSOLoaded) return null;

    return <this.SSOWrapperBase {...this.props} />;
  }
}

export const SSOWrapper = connect(
  mapStateToProps,
  mapDispatchToProps
)(DynamicImportSSO);
